import { OrganizationHeader } from "../components";
import Footer from "./Footer/Footer";
import styles from "./OrganizationLayout.module.css";
import UserLayout from "./UserLayout";

const AppProtectedLayout = ({ children }: any) => {
  return (
    <UserLayout>
      <OrganizationHeader />
      <div className={styles.content}>{children}</div>
      <Footer />
    </UserLayout>
  );
};

export default AppProtectedLayout;
